import { GridColProps, useIntersection } from '@bob/library'
import React, { FC } from 'react'

import * as SC from './BackgroundBrick.style'

export interface BackgroundBrickProps extends GridColProps {
  reversedLayout?: boolean
}

const buildThresholdArr = Array.from(Array(100).keys(), (i) => i / 100)

export const BackgroundBrick: FC<BackgroundBrickProps> = ({ reversedLayout }) => {
  const { observerEntry, observe } = useIntersection({
    rootMargin: '0px 0px -300px 0px',
    threshold: buildThresholdArr,
  })

  return (
    <SC.BackgroundBrickWrapper
      className={'background-brick'}
      data-testid={'background-brick'}
      desktop={5}
      desktopOffset={reversedLayout ? 0 : 7}
      parallaxOffset={
        observerEntry?.intersectionRatio &&
        (observerEntry?.boundingClientRect.top < 0 && observerEntry?.intersectionRatio < 1
          ? 1
          : observerEntry?.intersectionRatio) * 80
      }
    >
      <SC.BackgroundBrick
        ref={(ref: HTMLDivElement | null) => observe(ref)}
        reversedLayout={reversedLayout}
      />
    </SC.BackgroundBrickWrapper>
  )
}
